/*
 *  Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const SchufaWbsPageMeta = () => {
  const title = "Illegale Datenweitergabe an SCHUFA/CRIF: Aktuell keine neuen Mandate | WBS & Legalbird";
  const description =
    "Hinweise zur illegalen Weitergabe von Daten aus Telekommunikationsvertraegen an SCHUFA oder CRIF. Aktuell nehmen WBS und Legalbird in diesem Bereich keine neuen Mandate an.";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="WBS, Legalbird, SCHUFA, CRIF, Datenweitergabe, Telekommunikationsvertraege" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

export default SchufaWbsPageMeta;
